module.exports = __webpack_public_path__ + "img/icon_5_6.15342d9f.png";